import React, { useState } from 'react';
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';


const ReviewListTextFilter: React.FunctionComponent<{onTextFilter: (text: string) => void}> = ({onTextFilter})=> {

	const [text, setText] = useState('');

	const clear = () => {
		setText('');
		onTextFilter('');
	}

	const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Enter') {
			e.preventDefault();
			onTextFilter(text);
		}
	};

	return <div className="border-b border-t border-gray-200 bg-gray-50 px-6 py-2">
		<div className="flex items-center space-x-3">
			<div className="flex-grow">
				<div className="relative">
					<input type="text" className="input w-full h-8 pr-8" placeholder="Search reviews" value={text} onChange={(e) => setText(e.target.value)} onKeyDown={onKeyDown}/>
					<a className="absolute cursor-pointer bottom-1 p-1 right-1 text-gray-400 hover:text-blue-500" onClick={clear}><XMarkIcon className="h-4 w-4"/></a>
				</div>
			</div>
			<div>
				<button type="button" className="btn btn-white px-2.5 h-8 text-blue-600" onClick={() => onTextFilter(text)}>
					<MagnifyingGlassIcon className="h-4 w-4"/>
				</button>
			</div>
		</div>
	</div>
}

export default ReviewListTextFilter;